module.exports = __webpack_public_path__ + "img/bbshomepage2.103905b8.png";